// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spa-footer {
    padding-top: 2rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    font-size: 0.95rem;
    padding-bottom: env(safe-area-inset-bottom);
}

.spa-footer__section ul {
    list-style: none;
    padding: 0;
    margin: 0.5rem 0 0 0;
}

.spa-footer__section li {
    margin: 0.35rem 0;
}

.spa-footer__section a {
    text-decoration: none;
}

    .spa-footer__section a:hover {
        text-decoration: underline;
    }

.spa-footer__heading {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
}

/* --- Wider Screens: Multi-column layout --- */
@media (min-width: 768px) {
    .spa-footer {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        padding: 3rem 2rem;
    }

    .spa-footer__section {
        flex: 1 1 200px;
        max-width: 240px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Container/css/SPAFooter.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;IAEI;QACI,0BAA0B;IAC9B;;AAEJ;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,8BAA8B;QAC9B,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".spa-footer {\r\n    padding-top: 2rem;\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2rem;\r\n    font-size: 0.95rem;\r\n    padding-bottom: env(safe-area-inset-bottom);\r\n}\r\n\r\n.spa-footer__section ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0.5rem 0 0 0;\r\n}\r\n\r\n.spa-footer__section li {\r\n    margin: 0.35rem 0;\r\n}\r\n\r\n.spa-footer__section a {\r\n    text-decoration: none;\r\n}\r\n\r\n    .spa-footer__section a:hover {\r\n        text-decoration: underline;\r\n    }\r\n\r\n.spa-footer__heading {\r\n    margin: 0;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n}\r\n\r\n/* --- Wider Screens: Multi-column layout --- */\r\n@media (min-width: 768px) {\r\n    .spa-footer {\r\n        flex-direction: row;\r\n        flex-wrap: wrap;\r\n        justify-content: space-between;\r\n        align-items: flex-start;\r\n        padding: 3rem 2rem;\r\n    }\r\n\r\n    .spa-footer__section {\r\n        flex: 1 1 200px;\r\n        max-width: 240px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
